import React, { useState } from "react";
import ScrollToTop from "../ScrollToTop";
import Swal from "sweetalert2";

const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!form.name || !form.email || !form.message) {
      Swal.fire("Required", "Please fill all required fields", "warning");
      return;
    }

    Swal.fire({
      icon: "success",
      title: "Message Sent",
      text: "Thanks for contacting FreshCart. We’ll get back to you soon.",
      timer: 2000,
      showConfirmButton: false,
    });

    setForm({
      name: "",
      email: "",
      phone: "",
      message: "",
    });
  };

  return (
    <>
      <ScrollToTop />

      {/* HERO */}
      <section className="bg-light py-5">
        <div className="container text-center">
          <h1 className="fw-bold mb-2">Contact Us</h1>
          <p className="text-muted fs-5">
            We’re here to help. Feel free to reach out anytime.
          </p>
        </div>
      </section>

      {/* CONTENT */}
      <section className="container my-5">
        <div className="row g-4">
          
          {/* INFO */}
          <div className="col-lg-5">
            <div className="bg-success text-white rounded-4 p-4 h-100">
              <h4 className="fw-bold mb-3">FreshCart Support</h4>

              <p>
                Have questions about orders, delivery or business?  
                Contact us and we’ll assist you quickly.
              </p>

              <ul className="list-unstyled mt-4">
                <li className="mb-3">
                  📍 <strong>Address:</strong><br />
                  FreshCart, Nijhra,  Sonaili, Katihar, Bihar, India
                </li>

                <li className="mb-3">
                  📞 <strong>Phone:</strong><br />
                  +91 7856000970
                </li>

                <li className="mb-3">
                  📧 <strong>Email:</strong><br />
                  freshcart585@gmail.com
                </li>

                <li className="mb-3">
                  🧾 <strong>GST No:</strong><br />
                  10BSNPT0153M1CW
                </li>

                <li>
                  ⏰ <strong>Support Hours:</strong><br />
                  9 AM – 9 PM (All Days)
                </li>
              </ul>
            </div>
          </div>

          {/* FORM */}
          <div className="col-lg-7">
            <div className="bg-white shadow rounded-4 p-4">
              <h4 className="fw-bold mb-4">Send Message</h4>

              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Name *</label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={form.name}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Email *</label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Phone</label>
                    <input
                      type="tel"
                      className="form-control"
                      name="phone"
                      value={form.phone}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-12 mb-3">
                    <label className="form-label">Message *</label>
                    <textarea
                      className="form-control"
                      rows="4"
                      name="message"
                      value={form.message}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <button type="submit" className="btn btn-success btn-lg">
                  Send Message
                </button>
              </form>
            </div>
          </div>

        </div>
      </section>
    </>
  );
};

export default Contact;